import React from 'react';
import { getSearchIndexName } from '../../lib/search/searchUtil';
import SearchAutoComplete from "./SearchAutoComplete";
import PostsListEditorSearchHit from "./PostsListEditorSearchHit";

const PostsSearchAutoComplete = ({clickAction, placeholder='Search for posts'}: {
  clickAction: (id: string) => void,
  placeholder?: string
}) => {
  return <SearchAutoComplete
    indexName={getSearchIndexName("Posts")}
    resultType="Posts"
    clickAction={clickAction}
    renderSuggestion={(hit: any) => <PostsListEditorSearchHit hit={hit} />}
    placeholder={placeholder}
    noSearchPlaceholder='Post ID'
  />
}

export default PostsSearchAutoComplete;



